import actions from "./actions";

const proofTagModule = {
  state: {},
  mutations: {},
  actions,
  getters: {},
};

export default proofTagModule;
